import { Helmet } from "react-helmet-async";

const SITE_URL = "https://realprivy.com";

interface PageMetaProps {
  /** Unique page title, under 60 characters. */
  title: string;
  /** Unique page description, 50-160 characters. */
  description: string;
  /** Route path, e.g. "/terms". Used for the self-referencing canonical + og:url. */
  path: string;
  /** Set true for pages that should stay out of search results. */
  noindex?: boolean;
  children?: React.ReactNode;
}

export const PageMeta = ({ title, description, path, noindex, children }: PageMetaProps) => {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex ? <meta name="robots" content="noindex, follow" /> : null}
      {children}
    </Helmet>
  );
};

export default PageMeta;
